import { Expose, Type, plainToClass } from "class-transformer";

import { UserPolicy } from "./UserPolicy";
import { Consents } from "./userProfile/Consents";

export interface IUserProfile {
  id: number;
  uuid: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email: string;
  consents: Consents;
  policy: UserPolicy;
}

export class UserProfile {
  @Expose() id: number;
  @Expose() uuid: string;
  @Expose() firstName?: string;
  @Expose() lastName?: string;
  @Expose() phoneNumber?: string;
  @Expose() email: string;

  @Expose()
  @Type(() => Consents)
  consents: Consents;

  @Expose()
  @Type(() => UserPolicy)
  policy: UserPolicy;
}

export function transformToUserProfileClass(userProfile: unknown): UserProfile {
  return plainToClass(UserProfile, userProfile);
}

export default UserProfile;
